import { z } from "zod";

export type GeneralResult = z.infer<typeof GeneralResultSchema>;
export const GeneralResultSchema = z.object({
  message: z.string(),
  success: z.boolean().nullable(),
});
